/* import __COLOCATED_TEMPLATE__ from './teammate-filter-chip.hbs'; */
/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import Component from '@glimmer/component';
import { action } from '@ember/object';

interface TeammateFilterChipArgs {
  filterType: string;
  label: string;
  value: string;
  options: Array<{ text: string; value: string }>;
  onRemove: () => void;
  onChange: (value: string) => void;
}

export default class TeammateFilterChip extends Component<TeammateFilterChipArgs> {
  get optionsList() {
    return [
      {
        items: (this.args.options || []).map((option) => ({
          text: option.text,
          value: option.value,
        })),
      },
    ];
  }

  @action
  selectValue(value: string) {
    this.args.onChange(value);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Settings::Teams::TeammateFilterChip': typeof TeammateFilterChip;
    'settings/teams/teammate-filter-chip': typeof TeammateFilterChip;
  }
}
